// extracted by mini-css-extract-plugin
export default {"component":"YRPdy","error":"dJoex","arrow":"brhTQ"};